import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";

const MDPhoneInput = ({ value, onChange, error, ...rest }) => {
  return (
    <MDBox position="relative" mb={error ? 1 : 0}>
      <PhoneInput
        country="eg"
        value={value}
        onChange={onChange}
        enableSearch={true}
        inputStyle={{
          width: "100%",
          height: "45px",
          fontSize: "1.07rem",
          border: error ? "1px solid #F44335" : "1px solid #d2d6da",
          borderRadius: "8px",
          paddingLeft: "48px",
          paddingRight: "12px",
          backgroundColor: "transparent",
          fontFamily: "inherit",
        }}
        buttonStyle={{
          border: error ? "1px solid #F44335" : "1px solid #d2d6da",
          borderRight: "none",
          borderRadius: "8px 0 0 8px",
          backgroundColor: "transparent",
        }}
        containerStyle={{
          width: "100%",
          position: "relative",
          zIndex: 15,
        }}
        dropdownStyle={{
          borderRadius: "8px",
          border: "1px solid #d2d6da",
          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
          zIndex: 9999,
          position: "absolute",
          backgroundColor: "white",
          maxHeight: "200px",
          overflowY: "auto",
        }}
        inputProps={{
          name: "phone",
          required: true,
          autoComplete: "off",
          ...rest.inputProps,
        }}
        specialLabel=""
        isValid={(value, country) =>
          value && value.length >= country.dialCode.length + 7
        }
        {...rest}
      />
    </MDBox>
  );
};

MDPhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

export default MDPhoneInput;
